'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import Price from '@/app/_components/Price';

/**
 * TradeProgramCallout - Displays trade pricing for authenticated trade partners
 *
 * Shows trade price or price range based on selection completeness.
 * Receives all pricing data from useProduct hook rather than fetching independently.
 *
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.isComplete - Whether all product options are selected
 * @param {boolean} props.onSale - Whether the product is on sale
 * @param {boolean} props.isTradeAccount - Whether user is a trade account holder
 * @param {number|null} props.tradePrice - Calculated trade price (when complete)
 * @param {Object|null} props.tradePriceRange - { min, max } trade price range
 * @param {number} props.tradeDiscountRate - Trade discount rate (0.0 - 1.0)
 * @param {boolean} props.tradeDiscountOverridden - Whether sale price overrides trade discount
 */
const TradeProgramCallout = t0 => {
  const $ = _c(20);
  const {
    className: t1,
    isComplete: t2,
    onSale: t3,
    isTradeAccount: t4,
    tradePrice: t5,
    tradePriceRange: t6,
    tradeDiscountRate: t7,
    tradeDiscountOverridden: t8
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const isComplete = t2 === undefined ? false : t2;
  const onSale = t3 === undefined ? false : t3;
  const isTradeAccount = t4 === undefined ? false : t4;
  const tradePrice = t5 === undefined ? null : t5;
  const tradePriceRange = t6 === undefined ? null : t6;
  const tradeDiscountRate = t7 === undefined ? 0 : t7;
  const tradeDiscountOverridden = t8 === undefined ? false : t8;
  const [visible, setVisible] = useState(false);
  const shouldShow = isTradeAccount && (tradePrice !== null || tradePriceRange !== null);
  let t10;
  let t9;
  if ($[0] !== shouldShow) {
    t9 = () => {
      if (shouldShow) {
        const timer = setTimeout(() => setVisible(true), 10);
        return () => clearTimeout(timer);
      } else {
        setVisible(false);
      }
    };
    t10 = [shouldShow];
    $[0] = shouldShow;
    $[1] = t10;
    $[2] = t9;
  } else {
    t10 = $[1];
    t9 = $[2];
  }
  useEffect(t9, t10);
  if (!shouldShow) {
    return null;
  }
  let t11;
  if ($[3] !== tradeDiscountRate) {
    t11 = Math.round(tradeDiscountRate * 100);
    $[3] = tradeDiscountRate;
    $[4] = t11;
  } else {
    t11 = $[4];
  }
  const tradeDiscountPercent = t11;
  const t12 = `bg-gray-3 rounded px-4 pt-3 pb-3 transition-opacity duration-700 ease-in-out ${visible ? "opacity-100" : "opacity-0"} ${className}`;
  let t13;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="flex items-center"><FontAwesomeIcon icon={faHiveIconSmallLight} className="text-primary text-lg mr-2" /><span className="text-sm font-medium">Welcome Trade Partner</span></div>;
    $[5] = t13;
  } else {
    t13 = $[5];
  }
  let t14;
  if ($[6] !== isComplete || $[7] !== tradePrice || $[8] !== tradePriceRange) {
    t14 = <div className="flex items-center justify-between mb-2">{t13}<span className="text-sm font-medium">{isComplete && tradePrice !== null ? <Price amount={tradePrice} /> : tradePriceRange ? <><Price amount={tradePriceRange.min} /> - <Price amount={tradePriceRange.max} /></> : <Price amount={tradePrice} />}</span></div>;
    $[6] = isComplete;
    $[7] = tradePrice;
    $[8] = tradePriceRange;
    $[9] = t14;
  } else {
    t14 = $[9];
  }
  let t15;
  if ($[10] !== tradeDiscountOverridden || $[11] !== tradeDiscountPercent) {
    t15 = tradeDiscountOverridden ? <div className="text-sm text-ink-light-gray-bg mb-2">This item's sale price overrides your {tradeDiscountPercent}% trade discount.</div> : <div className="text-sm text-ink-light-gray-bg">Your {tradeDiscountPercent}% trade discount is applied at checkout.</div>;
    $[10] = tradeDiscountOverridden;
    $[11] = tradeDiscountPercent;
    $[12] = t15;
  } else {
    t15 = $[12];
  }
  let t16;
  if ($[13] !== onSale) {
    t16 = onSale && <div className="text-2xs text-ink-light-gray-bg mt-1">We always apply the best available discount automatically.<sup className="text-primary">*</sup></div>;
    $[13] = onSale;
    $[14] = t16;
  } else {
    t16 = $[14];
  }
  let t17;
  if ($[15] !== t12 || $[16] !== t14 || $[17] !== t15 || $[18] !== t16) {
    t17 = <div className={t12}>{t14}{t15}{t16}</div>;
    $[15] = t12;
    $[16] = t14;
    $[17] = t15;
    $[18] = t16;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  return t17;
};
export default TradeProgramCallout;